export default {
  amber600: '#CE9034',
  amber200: '#FFD08B',
  amber50: '#FFF3E1',
  copper: '#C17A52',
  greenDeselected: 'rgba(14, 41, 33, 0.5)',
  grey: '#D9D9D9',
  greyActive: 'rgba(0, 0, 0, 0.04)',
  greyMedium: '#B9B9B9',
  jade200: '#8FD6BD',
  jade500: '#3EA480',
  skyGrey: '#f2f4f5',
  lightGrey: '#F1F1F1',
  neutral: '#E8E6DF',
  neutral100: '#E7E5CC',
  neutral200: '#D2D1B7',
  neutral400: '#A7A68F',
  neutral500: '#8A8979',
  neutral50: '#FFFEEB',
  pink200: '#ECA1C7',
  pink50: '#FFDCEE',
  pink600: '#AF5F88',
  pink800: '#6D3652',
  spruce10: 'rgba(38, 77, 65, 0.1)',
  spruce50: '#DBF1EB',
  spruce100: '#97BDB2',
  spruce200: '#78A195',
  spruce300: 'rgba(38, 77, 65, 0.3)',
  spruce400: '#496A60',
  spruce500: '#264D41',
  spruce600: '#193930',
  spruce700: '#0E2921',
  spruceDisabled: 'rgba(38,77,65, 0.5)',
  spruceOpaque: 'rgba(39, 79, 67, 0)',
  sunshine100: '#FFF1C2',
  white: '#FFFFFF',
  whiteShadow: 'rgba(0, 0, 0, 0.15)',
  iconPink: '#ECA1C7',
  iconLine: '#0C3026',
  iconYellowDark: '#FFF26B',
  iconYellowLight: '#8FD6BD',
  iconGreen: '#F9E65D',
  red: '#e63f3b',
  cactus: '#1a8a74',
  shadow: 'rgba(12, 32, 45, 0.1)',
};
